import { render, staticRenderFns } from "./CardTableSlugsBase.vue?vue&type=template&id=5e908bf6&scoped=true&"
import script from "./CardTableSlugsBase.vue?vue&type=script&lang=js&"
export * from "./CardTableSlugsBase.vue?vue&type=script&lang=js&"
import style0 from "./CardTableSlugsBase.vue?vue&type=style&index=0&id=5e908bf6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e908bf6",
  null
  
)

export default component.exports